import React from 'react';
import { useStripeConnect } from './useStripeConnect';
import OnboardingForm from './OnboardingForm';
import OnboardingStatus from './OnboardingStatus';
import { useGetCurrentUserQuery } from '../../../redux/apis';

const MerchantOnboarding = () => {
  const { data: user } = useGetCurrentUserQuery();
  const stripeConnect = useStripeConnect(user?.stripeAccountId);

  if (!stripeConnect) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-teal"></div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">
          Complete Your Merchant Profile
        </h1>
        
        <OnboardingStatus status={user?.stripeAccountStatus} />
        
        {!user?.stripeAccountStatus?.detailsSubmitted && (
          <OnboardingForm stripeConnect={stripeConnect} />
        )}
      </div>
    </div>
  );
};

export default MerchantOnboarding; 